<template>
    <div class="settings includes-header">

        <header class="page-header settings-header settings-header--finished">
            <img src="/build/img/balloons.png" srcset="/build/img/balloons@2x.png 2x" width="135" alt="Ballonnen" class="image--balloons">
            <h1>Het jaar zit er weer op!</h1>
            <hr>
        </header>

        <group :user="user" :finished="true" @done="done"></group>


    </div>
</template>


<script>

import Group from 'js/components/settings/Group.vue'

export default {
    name: 'GroupArchived',
    props: {
        inModal: {
            type: Boolean,
            default: false,
        },
        user: {},
    },
    components: { Group },

    computed: {

    },

    methods: {

        done: function() {
            this.$emit('close')
        }

    }
}
</script>


<style lang="scss">

    @import 'global';

    .image--balloons {
        width: 135px !important;
        margin: -14px auto !important;
    }

    .settings-header--finished {
        margin-top: 2em;
    }

</style>



// WEBPACK FOOTER //
// Archived.vue?1a95b625